'use strict';

var _require = require('./helpers'),
    fv = _require.fv,
    cf = _require.cf,
    npv = _require.npv,
    calcReturn = _require.calcReturn,
    returnFactor = _require.returnFactor;

function constants(state) {
  var investmentPeriodReturn = calcReturn(state.investmentPeriodReturn, state.customInvestmentPeriodEquity, state.assetClassReturns);

  var spendingPeriodReturn = state.goalType === 'parallel' ? investmentPeriodReturn : calcReturn(state.spendingPeriodReturn, state.customSpendingPeriodEquity, state.assetClassReturns);

  var rf = Math.pow(1 + investmentPeriodReturn, 1 / 12);

  var k = rf * ((1 - Math.pow(rf, 12)) / (1 - rf));

  var spendOutflows = cf(state.currentSpend, state.inflation, state.spendStartAge - state.age, state.spendStopAge - state.age, state.spendFrequency);

  var startingAllocationFV = fv(investmentPeriodReturn, state.spendStartAge - state.age, state.startingAllocation);

  var spendStartNPV = npv(spendingPeriodReturn, spendOutflows);

  var toFinanceWithRegularInvestments = (spendStartNPV - startingAllocationFV) / Math.pow(1 + investmentPeriodReturn, state.spendStartAge - state.investStopAge);

  var regularInvestment = state.goalType === 'perpetual' ? state.currentSpend : toFinanceWithRegularInvestments / (k * returnFactor(investmentPeriodReturn, state.inflation, state.investStopAge - state.investStartAge));

  var maxStartingAllocation = state.goalType === 'perpetual' ? 1000000000 : spendStartNPV / Math.pow(1 + investmentPeriodReturn, state.spendStartAge - state.age);

  return {
    investmentPeriodReturn: investmentPeriodReturn,
    spendingPeriodReturn: spendingPeriodReturn,
    k: k,
    spendOutflows: spendOutflows,
    regularInvestment: regularInvestment,
    maxStartingAllocation: maxStartingAllocation
  };
}

module.exports = constants;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cmw-goaltools/dist/lib/constants.js
// module id = 115
// module chunks = 0